<template>
  <div>
    <div class="course-header">更换老师</div>
    <div class="course-about">
      <el-breadcrumb separator-class="el-icon-d-arrow-right" text-color="#FC5623">
        <!-- :to="{path: '/member/leave/teacher' }" -->
        <el-breadcrumb-item :to="{path: '/member/study' }" >更换老师</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/member/memberteacher' }">选择老师</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/member/leave/leavefrequency' }">选择更换老师后课程一周安排方式</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/member/leave/timeleavetime' }">选择一周具体时间安排</el-breadcrumb-item>
        <el-breadcrumb-item>更换老师成功</el-breadcrumb-item>
      </el-breadcrumb> 
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "Memberreplaceteacher",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.course-header {
  background-color: #ffffff;
  line-height: 60px;
  padding-left: 30px;
  font-weight: bold;
  margin-bottom: 30px;
}
.course-about {
  background-color: #ffffff;
  padding: 30px;
}
</style>
